var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('entity-comment-input');
import { breakpoints, theme } from '@shapeable/theme';
import { MentionsInput, Mention } from 'react-mentions';
import { trim } from 'lodash';
// import { ImageElement } from '../elements/image-element';
import { ClipLoader as Spinner } from 'react-spinners';
import { Loader } from '../elements/loader';
import { EntityTypeIcon } from './entity-type-icon';
import { CellLabel } from '../elements/cell-label';
import { useLang } from '../hooks/use-lang';
import { SendIconGlyph, TickIcon, useIcons } from '@shapeable/icons';
import { EntityValue } from './entity-value';
import { useWindowWidth } from '@react-hook/window-size';
import { IconButton } from '../elements/icon-button';
import { EntityBubbleImage } from './entity-bubble-image';
import { useActivePerson } from '../hooks/use-active-person';
export var EntityCommentInputDefaultProps = {
  showAvatar: true,
  isReply: false,
  disabled: false,
  variant: 'line'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    align-items: flex-start;\n    overflow: visible;\n    border: 1px solid ", ";\n    border-radius: ", ";\n\n    ", "\n\n    ", "\n\n    .entity-comment-input {\n      flex-grow: 1;\n    }\n\n    .entity-comment-input__highlighter {\n      overflow: visible !important;\n    }\n\n    \n\n    .entity-comment-input__input {\n      border: none;\n      font-size: 1em;\n      max-width: 600px;\n      font-family: ", ";\n      color: ", ";\n      \n      ", "\n\n      &::placeholder {\n        color: ", ";\n      }\n\n      &:focus {\n        outline: none;\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    }\n\n\n\n    .entity-comment-input__suggestions__list {\n      box-shadow: 0px 2px 4px -3px rgba(0, 0, 0, 0.2); \n      border: 1px solid ", ";\n    }\n\n    .entity-comment-input__mention {\n      background-color: ", ";\n      margin-left: 1px;\n      margin-top: -1px;\n      border-bottom: 1px solid ", ";\n      border-top: 1px solid ", ";\n      font-weight: 400;\n    }\n\n    \n    .entity-comment-input__suggestions__item {\n      border-bottom: 1px solid ", ";\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    ", "\n  "], ["\n    font-size: ", ";\n    display: flex;\n    align-items: flex-start;\n    overflow: visible;\n    border: 1px solid ", ";\n    border-radius: ", ";\n\n    ", "\n\n    ", "\n\n    .entity-comment-input {\n      flex-grow: 1;\n    }\n\n    .entity-comment-input__highlighter {\n      overflow: visible !important;\n    }\n\n    \n\n    .entity-comment-input__input {\n      border: none;\n      font-size: 1em;\n      max-width: 600px;\n      font-family: ", ";\n      color: ", ";\n      \n      ", "\n\n      &::placeholder {\n        color: ", ";\n      }\n\n      &:focus {\n        outline: none;\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    }\n\n\n\n    .entity-comment-input__suggestions__list {\n      box-shadow: 0px 2px 4px -3px rgba(0, 0, 0, 0.2); \n      border: 1px solid ", ";\n    }\n\n    .entity-comment-input__mention {\n      background-color: ", ";\n      margin-left: 1px;\n      margin-top: -1px;\n      border-bottom: 1px solid ", ";\n      border-top: 1px solid ", ";\n      font-weight: 400;\n    }\n\n    \n    .entity-comment-input__suggestions__item {\n      border-bottom: 1px solid ", ";\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    ", "\n  "])), theme.FONT_SIZE(16), theme.COLOR('line-subtle'), theme.UNIT(2), function (props) {
    return (props.isReply || props.isEdit) && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: none;\n    "], ["\n      border: none;\n    "])));
  }, function (props) {
    return props.isFocussed && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-color: ", ";\n      ", ";\n    "], ["\n      border-color: ", ";\n      ", ";\n    "])), theme.COLOR('line'), theme.TRANSITION('border-color'));
  }, theme.FONT('sans'), theme.COLOR('text'), function (props) {
    return props.variant === 'box' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        max-width: 100%;\n      "], ["\n        max-width: 100%;\n      "])));
  }, theme.COLOR('text-subtle'), theme.COLOR('text'), theme.COLOR('line-subtle'), theme.COLOR('primary-very-light'), theme.COLOR('primary-light'), theme.COLOR('primary-very-light'), theme.COLOR('line-subtle'), function (props) {
    return props.disabled && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      .entity-comment-input__input {\n        opacity: 0.2;\n      }\n    "], ["\n      .entity-comment-input__input {\n        opacity: 0.2;\n      }\n    "])));
  }),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(15))
});
var BodyStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-grow: 1;\n  "], ["\n    flex-grow: 1;\n  "])))
});
var InputWrapperStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n  "], ["\n  ", "\n  "])), function (props) {
    return (props.isReply || props.isEdit) && props.isFocussed && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])));
  })
});
var InputStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    padding: ", " ", ";\n    \n    display: flex;\n    flex-grow: 1;\n    height: 60px;\n\n    ", "\n  \n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    padding: ", " ", ";\n    \n    display: flex;\n    flex-grow: 1;\n    height: 60px;\n\n    ", "\n  \n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.UNIT(3), theme.UNIT(2), function (props) {
    return props.variant === 'box' && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      max-width: 100%;\n      box-sizing: border-box;\n      padding: ", ";\n      border: 1px solid ", ";\n      background: #FFF;\n    "], ["\n      max-width: 100%;\n      box-sizing: border-box;\n      padding: ", ";\n      border: 1px solid ", ";\n      background: #FFF;\n    "])), theme.UNIT(3), theme.COLOR('line-subtle'));
  }, function (props) {
    return props.isReply && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      padding-top: ", ";\n      border-bottom: 1px solid ", ";\n      height: 20px;\n    "], ["\n      padding-top: ", ";\n      border-bottom: 1px solid ", ";\n      height: 20px;\n    "])), theme.UNIT(1.5), theme.COLOR('line-subtle'));
  }, function (props) {
    return props.isEdit && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      padding-top: 0px;\n      border-bottom: 1px solid ", ";\n      height: 20px;\n    "], ["\n      padding-top: 0px;\n      border-bottom: 1px solid ", ";\n      height: 20px;\n    "])), theme.COLOR('line-subtle'));
  }, function (props) {
    return props.isFocussed && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      border-bottom: none;\n    "], ["\n      border-bottom: none;\n    "])));
  }, function (props) {
    return (props.isReply || props.isEdit) && props.isFocussed && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n      ", ";\n    "], ["\n      border-bottom: 1px solid ", ";\n      ", ";\n    "])), theme.COLOR('line'), theme.TRANSITION('border-bottom'));
  })
});
var SuggestionStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding: ", " ", ";\n\n  "], ["\n    display: flex;\n    align-items: center;\n    padding: ", " ", ";\n\n  "])), theme.UNIT(1.5), theme.UNIT(2))
});
var PhotoStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(2))
});
var SuggestionNameStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: 500;\n    display: flex;\n    flex-direction: column;\n  "], ["\n    font-size: 1em;\n    font-weight: 500;\n    display: flex;\n    flex-direction: column;\n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    opacity: 0.3;\n    cursor: default;\n    ", "\n  "], ["\n    opacity: 0.3;\n    cursor: default;\n    ", "\n  "])), function (props) {
    return props.hasValue && css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      opacity: 1;\n      cursor: pointer;\n\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "], ["\n      opacity: 1;\n      cursor: pointer;\n\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "])));
  })
});
var PostButtonStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    font-size: ", ";\n    ", ";\n    \n  "], ["\n    font-size: ", ";\n    ", ";\n    \n  "])), theme.FONT_SIZE(13), ButtonStyles)
});
var CancelButtonStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    \n    font-size: ", ";\n    margin-left: ", ";\n    padding: ", ";\n\n    font-weight: 500;\n    color: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n\n    &:hover {\n      cursor: pointer;\n      color: ", ";\n      background-color: ", ";\n    }\n  "], ["\n    \n    font-size: ", ";\n    margin-left: ", ";\n    padding: ", ";\n\n    font-weight: 500;\n    color: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n\n    &:hover {\n      cursor: pointer;\n      color: ", ";\n      background-color: ", ";\n    }\n  "])), theme.FONT_SIZE(14), theme.UNIT(4.5), theme.UNIT(2), theme.COLOR('mid'), theme.COLOR('app-chrome'), theme.UNIT(2), theme.COLOR('mid'), theme.COLOR('line-subtle'))
});
var SendIconStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    ", ";\n    padding-left: ", ";\n  "], ["\n    ", ";\n    padding-left: ", ";\n  "])), ButtonStyles, theme.UNIT(2))
});
var CreatorStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(3))
});
var ImageStyles = breakpoints({
  base: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    height: 24px;\n    margin-right: ", ";\n  "], ["\n    height: 24px;\n    margin-right: ", ";\n  "])), theme.UNIT(2))
});
var SpinnerStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    flex-shrink: 0;\n    svg {\n      ", ";\n    }\n  "], ["\n    flex-shrink: 0;\n    svg {\n      ", ";\n    }\n  "])), theme.FILL('primary'))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 32px;\n    background-color: ", ";\n    border-radius: 0 0 ", " ", ";\n    padding: ", " ", ";\n    overflow: visible;\n\n    \n\n    ", "\n    \n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 32px;\n    background-color: ", ";\n    border-radius: 0 0 ", " ", ";\n    padding: ", " ", ";\n    overflow: visible;\n\n    \n\n    ", "\n    \n    ", "\n  "])), theme.COLOR('app-chrome'), theme.UNIT(2), theme.UNIT(2), theme.UNIT(3), theme.UNIT(2), function (props) {
    return (props.isEdit || props.isReply) && props.isFocussed && css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n        overflow: hidden;\n        max-height: 22px;\n        opacity: 1;\n        visibility: visible;\n        ", ";\n        height: auto; \n        background-color: ", ";\n      "], ["\n        overflow: hidden;\n        max-height: 22px;\n        opacity: 1;\n        visibility: visible;\n        ", ";\n        height: auto; \n        background-color: ", ";\n      "])), theme.TRANSITION('max-height, opacity, visibility'), theme.COLOR('subtle-chrome'));
  }, function (props) {
    return (props.isEdit || props.isReply) && !props.isFocussed && css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n        overflow: hidden;\n        max-height: 0;\n        opacity: 0;\n        visibility: hidden;\n        ", ";\n      "], ["\n        overflow: hidden;\n        max-height: 0;\n        opacity: 0;\n        visibility: hidden;\n        ", ";\n      "])), theme.TRANSITION('max-height, opacity, visibility'));
  })
});
var LoaderStyles = breakpoints({
  base: css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: 1.2em;\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    font-size: ", ";\n    line-height: 1.2em;\n    flex-direction: row;\n    align-items: center;\n  "])), theme.FONT_SIZE(13))
});
var EntityIconStyles = breakpoints({
  base: css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(2))
});
var LabelStyles = breakpoints({
  base: css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    color: ", ";\n    font-size: ", ";\n  "], ["\n    margin-bottom: ", ";\n    color: ", ";\n    font-size: ", ";\n  "])), theme.UNIT(1), theme.COLOR('text-subtle'), theme.FONT_SIZE(12))
});
var TypeLabelStyles = breakpoints({
  base: css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    font-weight: 500;\n    color: ", ";\n  "], ["\n    font-weight: 500;\n    color: ", ";\n  "])), theme.COLOR('primary'))
});
var EntityValueStyles = breakpoints({
  base: css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    padding: ", ";\n    ", "\n  "], ["\n    padding: ", ";\n    ", "\n  "])), theme.UNIT(3), function (props) {
    return props.focused && css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), theme.COLOR('primary-very-light'), theme.COLOR('primary-darker'));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  InputWrapper: styled.div(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), InputWrapperStyles),
  Input: styled.div.attrs(cls.attr('titles'))(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Avatar: styled(EntityBubbleImage)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), CreatorStyles),
  Suggestion: styled.div(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), SuggestionStyles),
  Label: styled(CellLabel)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  TypeLabel: styled(CellLabel)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), TypeLabelStyles),
  SuggestionName: styled.span(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), SuggestionNameStyles),
  Photo: styled(EntityBubbleImage)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  // Image: styled(ImageElement)`${ImageStyles}`,
  Spinner: styled(Spinner)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles),
  Loader: styled(Loader)(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  EntityTypeIcon: styled(EntityTypeIcon)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), EntityIconStyles),
  EntityValue: styled(EntityValue)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), EntityValueStyles),
  Controls: styled.div(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  PostButton: styled(IconButton)(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), PostButtonStyles),
  CancelButton: styled(IconButton)(templateObject_52 || (templateObject_52 = __makeTemplateObject(["", ""], ["", ""])), CancelButtonStyles),
  SaveButton: styled(IconButton)(templateObject_53 || (templateObject_53 = __makeTemplateObject(["", ""], ["", ""])), CancelButtonStyles),
  SendIcon: styled(IconButton)(templateObject_54 || (templateObject_54 = __makeTemplateObject(["", ""], ["", ""])), SendIconStyles)
};
export var EntityCommentInput = function (props) {
  // const entities = useEntities();
  var t = useLang();
  var Icons = useIcons();
  var windowWidth = useWindowWidth();
  var activePerson = useActivePerson();
  var _a = __read(useState(false), 2),
    focussed = _a[0],
    setFocussed = _a[1];
  var inputRef = useRef(null);
  var className = props.className,
    showAvatar = props.showAvatar,
    isReply = props.isReply,
    onSubmit = props.onSubmit,
    isEdit = props.isEdit,
    isSubmitting = props.isSubmitting,
    initialValue = props.initialValue,
    disabled = props.disabled,
    autoFocus = props.autoFocus,
    onCancel = props.onCancel,
    variant = props.variant,
    isMainInput = props.isMainInput;
  var placeholder = t(props.placeholder || (isReply ? windowWidth < 600 ? 'Write a reply' : 'Reply' : windowWidth < 600 ? 'Comment' : 'Write a comment'));
  var mentioneableEntities = ['Person', 'Team', 'Organisation', 'FeedEntry', 'Video'];
  // const entities = useEntityTypeDefinitions();
  // const MENTIONS_QUERY = useMemo(() => {
  //   const inner = reduce(mentioneableEntities, (acc, entityTypeName) => {
  //     const defn = entities[entityTypeName];
  //     if (true) {
  //       return `
  //         ${acc}
  //         list${defn.pluralLabel}${entityTypeName === 'Person' ? `(filter: { hasAccount: { is: true } })` : ''} {
  //           results {
  //             id
  //             name
  //             slug
  //             openGraph { id image { id url } }
  //           }
  //         }
  //       `;
  //     }
  //     return acc;
  //   }, '');
  //   return gql`
  //     query MentionsQuery {
  //       ${inner}
  //     }
  //   `
  // }, [activePerson]);
  // const { data = {}, loading } = useQuery(MENTIONS_QUERY);
  // const allEntities: Entity[] = [
  //   ...((data.listPeople && data.listPeople.results || [])),
  //   ...((data.listTeams && data.listTeams.results || [])),
  //   ...((data.listOrganisations && data.listOrganisations.results || [])),
  //   ...((data.listFeedEntries && data.listFeedEntries.results || [])),
  //   ...((data.listVideos && data.listVideos.results || [])),
  // ];
  var postLabel = t('Submit');
  var cancelLabel = t('Cancel');
  var saveLabel = t('Save');
  // const { person } = personResult;
  // const creator = props.creator || person;
  var creator = props.creator;
  useEffect(function () {
    // Moving cursor to the end
    if (autoFocus && inputRef && inputRef.current) {
      inputRef.current.selectionStart = inputRef.current.value.length;
      inputRef.current.selectionEnd = inputRef.current.value.length;
    }
  }, []);
  var _b = __read(React.useState(initialValue), 2),
    value = _b[0],
    setValue = _b[1];
  var onChange = function (event, newValue, newPlainTextValue, options) {
    setValue(newValue);
  };
  // END TODO
  var handleSubmit = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!onSubmit) return [3 /*break*/, 2];
            return [4 /*yield*/, onSubmit({
              value: value
            })];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };
  var handleKeyDown = function (event) {
    if (event.keyCode === 13 && !event.shiftKey) {
      handleSubmit();
    } else if (event.keyCode === 27) {
      handleCancel();
    }
  };
  var handleCancel = function () {
    setValue('');
    if (onCancel) {
      onCancel();
    }
  };
  // const renderSuggestion: (entry: EntitySuggestion, search: string, highlightedDisplay: any, index: number, focused: boolean) => React.ReactNode = 
  //   (entry, search, highlightedDisplay, index, focused) => {
  //     const defn = entitiesDict[entry.__typename];
  //     const label = defn && defn.label;
  //     return <My.EntityValue highlight={search} focused={focused} entity={entry} />;
  //   };
  var mentionEntity = function (search, callback) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        // if (search) {
        //   if (allEntities.length) {
        //     const filteredResults = filter(allEntities, result => (!creator || (result.id !== creator.id)) && startsWith(result.name.toUpperCase(), search.toUpperCase()) );
        //     const mappedResults = filteredResults.map((entity: Entity) => ({ ...entity, id: `${(entities[entity.__typename] && `${entities[entity.__typename].}/`)}${entity.slug}`, display: entity.name }));
        //     callback(mappedResults);
        //   }
        // }
        return [2 /*return*/, []];
      });
    });
  };
  var avatarSize = isReply ? 32 : 40;
  var hasValue = value && !!trim(value);
  var showControls = hasValue || isEdit;
  // const modal = useModal();
  var ref = useRef();
  var onFocus = function () {
    return setFocussed(true);
  };
  var onBlur = function () {
    return setFocussed(false);
  };
  return React.createElement(My.Container, {
    ref: ref,
    variant: variant,
    disabled: disabled || isSubmitting,
    className: className,
    isFocussed: focussed,
    isEdit: isEdit,
    isReply: isReply
  }, creator && showAvatar && React.createElement(My.Avatar, {
    size: avatarSize,
    entity: creator
  }), React.createElement(My.Body, null, React.createElement(My.InputWrapper, {
    isEdit: isEdit,
    isReply: isReply,
    isFocussed: focussed
  }, React.createElement(My.Input, {
    title: t('Use the Return key to submit. To force a line-break, use Shift-Return.'),
    isFocussed: focussed,
    disabled: disabled,
    variant: variant,
    isEdit: isEdit,
    isReply: isReply
  }, React.createElement(MentionsInput, {
    allowSuggestionsAboveCursor: true,
    forceSuggestionsAboveCursor: true,
    inputRef: inputRef,
    onKeyDown: handleKeyDown,
    autoFocus: autoFocus,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled || isSubmitting,
    placeholder: placeholder,
    className: "entity-comment-input",
    value: value,
    suggestionsPortalHost: ref && ref.current,
    onChange: onChange
  }, React.createElement(Mention, {
    trigger: "@",
    markup: "@[__display__](/platform/__id__)",
    data: mentionEntity,
    className: "entity-comment-input__mention",
    // renderSuggestion={renderSuggestion}
    appendSpaceOnAdd: true
  })))),
  // showControls &&
  React.createElement(My.Controls, {
    isEdit: isEdit,
    isReply: isReply,
    hasValue: hasValue,
    isFocussed: focussed,
    isLoading: isSubmitting
  }, isSubmitting ? React.createElement(My.Loader, {
    spaceUnits: 2,
    spinnerSize: 16
  }, isEdit ? t('Updating...') : t('Submitting...')) : React.createElement(React.Fragment, null, hasValue && (isEdit || isReply) && React.createElement(My.CancelButton, {
    showChildren: true,
    hasValue: hasValue,
    onClick: handleCancel
  }, cancelLabel), isEdit && hasValue && React.createElement(My.SaveButton, {
    showChildren: true,
    hasValue: hasValue,
    iconSize: 18,
    icon: React.createElement(TickIcon, null),
    onClick: handleSubmit
  }, saveLabel), !isEdit && isReply && React.createElement(My.SendIcon, {
    iconColor: 'primary',
    iconSize: 34,
    hasValue: hasValue,
    icon: React.createElement(SendIconGlyph, null),
    onClick: handleSubmit
  }), !isEdit && !isReply && isMainInput && React.createElement(My.SendIcon, {
    iconColor: 'primary',
    iconSize: 34,
    hasValue: hasValue,
    icon: React.createElement(SendIconGlyph, null),
    onClick: handleSubmit
  })))));
};
EntityCommentInput.defaultProps = EntityCommentInputDefaultProps;
EntityCommentInput.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54;